import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-file-download",
  "use": "icon-file-download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file-download\"><path d=\"M810.56 384h-170.656V128h-256v256H213.248l298.656 298.656L810.592 384zM213.28 768v85.344h597.344V768H213.248z\" p-id=\"1497\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol